import React, { useState } from "react";
import clsx from "clsx";
import { Box, Popover } from "@material-ui/core";
import { useSelectedTheme } from "../../../../../../../../Hooks";
import { CustomButton, CustomSelect } from "../../../../../../../../Components";

// Styles
import useStyles from "./styles";

// Icons
import {
  FilterIcon,
  FilterEqualIcon,
  CloseXIcon,
  FilterGreaterThan,
  FilterLessThan,
} from "../../../../../../../../assets/icons";

const PaymentPlanTableHeader = ({
  params,
  title,
  hideSelect = false,
  hideInput = false,
  isHiddenFilter = false,
  inputType = "text",
  criteriaFilter = {},
  handleFilterConfirm = () => {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedValue, setSelectedValue] = useState(1);
  const [inputNameValue, setInputNameValue] = useState("");
  const [selectedNameValue, setSelectedNameValue] = useState(1);

  const key = params?.field || params?.colDef?.field;
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setInputValue("");
    setSelectedValue(1);
    setInputNameValue("");
    setSelectedNameValue(1);
  };

  const handleConfirmClick = () => {
    if (handleFilterConfirm) {
      handleFilterConfirm(
        params,
        title,
        inputValue,
        selectedValue,
        inputNameValue,
        selectedNameValue
      );
    }
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const TableFilterOperatorsEnum = (text) => ({
    equal: {
      id: 1,
      name: "Equal",
      fieldType: "text",
      icon: (
        <FilterEqualIcon fill={text.secondary} height="16px" width="16px" />
      ),
    },
    greaterThan: {
      id: 3,
      name: "Greater Than Or Equal",
      fieldType: "text",
      icon: (
        <FilterGreaterThan fill={text.secondary} height="16px" width="16px" />
      ),
    },
    lessThan: {
      id: 4,
      name: "Less Than Or Equal",
      fieldType: "text",
      icon: <FilterLessThan fill={text.secondary} height="16px" width="16px" />,
    },
  });

  const TableStatusEnum = () => ({
    active: {
      id: 1,
      name: "Active",
      fieldType: "text",
    },
    inactive: {
      id: 2,
      name: "Inactive",
      fieldType: "text",
    },
  });

  return (
    <>
      <Box className={styles.headerCell}>
        {title}
        {!isHiddenFilter && (
          <FilterIcon
            onClick={handleClick}
            width="15"
            height="15"
            fill={
              Object.keys(criteriaFilter || [])
                ?.map((str) => str?.toLowerCase())
                ?.some(
                  (element) =>
                    key?.toLowerCase() === element ||
                    key?.toLowerCase()?.includes(element)
                )
                ? palette.border.brandSolid
                : palette.text.tertiary
            }
          />
        )}
      </Box>

      <Popover
        elevation={0}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handlePopoverClick}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box className={styles.contactPopupContainerStyle}>
          <Box className={styles.popupHeader}>
            <h4 className={styles.h4}>{title}</h4>
            <CloseXIcon
              width="20"
              height="20"
              fill={palette.foreground.disabled}
              style={{ cursor: "pointer" }}
              onClick={handleClose}
            />
          </Box>

          <Box className={styles.defaultMargin}>
            {!hideInput ? (
              <Box className={clsx(styles.customInput)}>
                {!hideSelect && (
                  <CustomSelect
                    variant="custom"
                    onValueChange={setSelectedValue}
                    emptyItem={{ id: 0, name: "Select", isDisabled: true }}
                    defaultValue={1}
                    options={Object.values(
                      TableFilterOperatorsEnum(palette.text)
                    )}
                    IconComponent={<FilterEqualIcon />}
                    value={selectedValue}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                  />
                )}

                <input
                  className={clsx(styles.BasicInput, {
                    [styles.placeholder]: !inputValue,
                  })}
                  type={inputType}
                  min={inputType === "number" ? 0 : undefined}
                  placeholder={`Enter ${title}`}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </Box>
            ) : (
              <Box className={clsx(styles.customInput)}>
                <CustomSelect
                  variant="custom"
                  style={{ width: "100%", maxWidth: "97%" }}
                  onValueChange={setSelectedValue}
                  emptyItem={{ id: 0, name: "Select", isDisabled: true }}
                  defaultValue={1}
                  options={Object.values(TableStatusEnum())}
                  IconComponent={<FilterEqualIcon />}
                  value={selectedValue}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                />
              </Box>
            )}
          </Box>

          <Box className={styles.actions}>
            <CustomButton
              boxShadow="xs"
              size="popupAction"
              variant="outlined"
              color="secondary"
              onClick={handleClose}
            >
              Cancel
            </CustomButton>
            <CustomButton
              disabled={
                hideInput
                  ? !selectedValue
                  : !(
                      (selectedValue && inputValue.trim().length > 0) ||
                      (selectedNameValue && inputNameValue.trim().length > 0)
                    )
              }
              boxShadow="xs"
              size="popupAction"
              variant="contained"
              color="primary"
              onClick={handleConfirmClick}
            >
              Confirm
            </CustomButton>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default PaymentPlanTableHeader;
